import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "../../data/site";
import { areas } from "../../data/areas";
import Icon from "../UI/Icon";

// Map a listed area name to a dedicated area page slug where one exists.
const areaLink = (name) => {
  const match = areas.find((a) => a.name.startsWith(name));
  return match ? `/areas/${match.slug}` : null;
};

export default function Areas() {
  return (
    <section className="bg-paper">
      <div className="max-w-site mx-auto px-5 sm:px-10 py-16 md:py-20">
        <div className="bg-bark text-paper relative overflow-hidden">
          <div className="grain relative p-8 sm:p-12 lg:grid lg:grid-cols-[1fr_1.3fr] lg:gap-12 items-center">
            <div className="mb-8 lg:mb-0">
              <p className="eyebrow eyebrow--light mb-4">Where we work</p>
              <h2 className="font-display font-semibold text-3xl sm:text-4xl leading-tight">
                Carpenters covering Cambridge &amp; Cambridgeshire
              </h2>
              <p className="text-paper/80 leading-7 mt-4">
                Based just north of Cambridge, we cover the city and the surrounding villages. See the{" "}
                <Link to="/areas" className="text-brass underline underline-offset-4">
                  areas we cover
                </Link>
                , or further afield?{" "}
                <Link to="/contact" className="text-brass underline underline-offset-4">
                  Drop us a line
                </Link>
                .
              </p>
            </div>
            <ul className="flex flex-wrap gap-2.5">
              {SITE.areas.map((area) => {
                const to = areaLink(area);
                const base =
                  "flex items-center gap-1.5 border px-3.5 py-2 text-sm transition-colors";
                return (
                  <li key={area}>
                    {to ? (
                      <Link
                        to={to}
                        className={`${base} bg-white/10 border-brass/40 text-paper hover:bg-brass hover:text-ink`}
                      >
                        <Icon name="pin" className="w-4 h-4 text-brass" />
                        {area}
                      </Link>
                    ) : (
                      <span className={`${base} bg-white/5 border-white/10 text-paper/90`}>
                        <Icon name="pin" className="w-4 h-4 text-brass" />
                        {area}
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
